import { Highlight } from 'src/types/dto/Highlight';

export const DEMO_PAGE_EMPTY_HIGHLIGHT: Highlight = {};
